export const appTypo = {
  font: {
    roboto: "Roboto, sans-serif",
    notoJp: "Noto Sans JP, sans-serif",
  },
} as const;
